import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    BoxProps,
    IconButtonProps,
    Box as MuiBox,
    IconButton as MuiIconButton,
    styled,
    Theme,
    useMediaQuery,
} from "@mui/material";
import { useContext, useState } from "react";

import { Legend_Z_Index } from "src/const";
import { MapContext } from "src/contexts/map";

import FormOptions from "./FormOptions";

const Box = styled(MuiBox)<BoxProps & { ismobile: string }>(
    ({ theme, ismobile }) => ({
        zIndex: Legend_Z_Index,
        position: "absolute",
        bottom: ismobile === "true" ? theme.spacing(2) : theme.spacing(16),
        right: ismobile == "true" ? theme.spacing(2) : "1%",
        display: "flex",
        gap: theme.spacing(1),
    }),
);

const IconButton = styled(MuiIconButton)<
    IconButtonProps & { ismobile: string }
>(({ theme, ismobile }) => ({
    backgroundColor: theme.palette.primary.main,
    height: theme.spacing(5.7),
    width: theme.spacing(5.7),
    fontSize: "1rem",
    padding: theme.spacing(0),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: ismobile == "true" ? "50%" : theme.spacing(2),
}));

const Icon = styled(FontAwesomeIcon)(({ theme }) => ({
    alignContent: "center",
    color: theme.palette.common.white,
}));

const Actions: React.FC = () => {
    const { categories } = useContext(MapContext);

    const typesDetectedFromCategories = [
        ...new Set(
            categories
                .filter((item) => item.nature !== null)
                .map((item) => item.nature),
        ),
    ];

    const isSingleType = typesDetectedFromCategories.length === 1;

    const [openForm, setOpenForm] = useState(isSingleType);

    const handleAddElement = () => {
        setOpenForm(!openForm);
    };

    const isMobile = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down("md"),
    );

    return (
        <Box ismobile={isMobile.toString()}>
            <FormOptions
                addElement={openForm}
                onCloseForm={() => setOpenForm(false)}
            />

            {!isSingleType && (
                <IconButton
                    ismobile={isMobile.toString()}
                    disableRipple
                    disableFocusRipple
                    onClick={() => handleAddElement()}
                >
                    <Icon icon={faPlus} />
                </IconButton>
            )}
        </Box>
    );
};

export default Actions;
